var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrap sale-head"},[_c('router-link',{staticClass:"logo",attrs:{"to":{path:'/index'},"tag":"div"}},[_c('img',{attrs:{"src":require("../../assets/images/logo.png"),"alt":"logo"}})]),_vm._v("卖家工作台 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }